<div class="sdps-p-horizontal_medium">
  <sdps-notification type="information" class="sdps-m-top_none" *ngIf="showClientMsg">
    <p class="sdps-notification__text" [innerHTML]="getShellConstant.noCientSelected"></p>
  </sdps-notification>
</div>
<div class="sdps-p-horizontal_medium" *ngIf="!showClientMsg">
  <form [formGroup]="reportDetails">
    <div class="sdps-grid-container sdps-wrap report-dropdown">

      <div class="sdps-row sdps-p-top_x-large">
        <div class="display-flex">
          <app-report-from-to-datepicker (calendarValidation)="calendarValidation($event)" [dateRange]="730" [initialDateRange]="7" (getEmittedVal)="setDate($event)"
            [calendarForm]="reportDetails" [initialFromDate]="initialFromDate" [initialToDate]="initialToDate"
            (throwDateError)="throwDateError($event)" (throwDateRangeError)="throwDateRangeError($event)"></app-report-from-to-datepicker>
        </div>
      </div>

      <div class="sdps-row sdps-p-top_large select-report-type">
        <!-- Employee ID -->
        <div class="col-3 sdps-p-left_none"  *ngIf="businessUnit !== sharedConstant.rbsBUText">
          <div [ngClass]="{'invalidField': (reportDetails.get('employeeID').value && reportDetails.get('employeeID').invalid)}">
            <p-float-label variant="in">
              <input type="text" id="employeeID" name="employeeID" formControlName="employeeID" [maxLength]="35" emsEmployeeIdPatterncheck emsCharacterLimit
                [charMaxLimit]="getCommConst.charLimitValues.thirtyFiveMaxLimit" (emsCharacterLimitCheck)="showEmpIdCharLimit = $event" [uppercaseRequired]="true"
                pInputText/>
              <label for="employeeID" [innerHTML]="sharedConstant[businessUnit].empOrParticipantsID"></label>
            </p-float-label>
          </div>
          <p class="col-6 sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small" *ngIf="reportDetails.get('employeeID').value && reportDetails.get('employeeID').value.length > showEmpIdCharLimit">{{getShellConstant.reports.characterLimit}}
            <span class="character-limit">{{reportDetails.get('employeeID').value.length}} /{{getCommConst.charLimitValues.thirtyFiveMaxLimit}}
            </span>
          </p>
        </div>

        <!-- Account Number -->
        <div class="col-3 sdps-p-left_none">
          <div class="report-textbox-border" [ngClass]="{'invalidField': (reportDetails.get('employeeAccount').value  && (reportDetails.get('employeeAccount').invalid || reportDetails.get('employeeAccount').value.length <= 8))}">
            <p-float-label variant="in">
              <input type="text" id="employeeAccount" name="employeeAccount" [maxlength]="10" onkeypress="if(event.which<48 || event.which>57) return false;" emsAccountNumberFormat formControlName="employeeAccount" pInputText/>
              <label for="employeeAccount" [innerHTML]="getShellConstant.reports.presetReports.accountNumber"></label>
            </p-float-label>
          </div>
        </div>

        <!-- Employee Last Name -->
        <div class="col-3 sdps-p-left_none">
          <div [ngClass]="{'invalidField': (reportDetails.get('employeeLastName').value && reportDetails.get('employeeLastName').invalid)}">
            <p-float-label variant="in">
              <input type="text" id="employeeLastName" *ngIf="businessUnit === sharedConstant.rbsBUText" name="employeeLastName" [maxLength]="30" formControlName="employeeLastName" emsNamePatternCheck emsCharacterLimit
                (emsCharacterLimitCheck)="showTextboxCharLimit = $event" [charMaxLimit]="getCommConst.charLimitValues.thirtyMaxLimit" pInputText/>
              <input type="text" id="employeeLastName" *ngIf="businessUnit !== sharedConstant.rbsBUText" name="employeeLastName" [maxLength]="30" formControlName="employeeLastName" emsCharacterLimit
                (emsCharacterLimitCheck)="showTextboxCharLimit = $event" [charMaxLimit]="getCommConst.charLimitValues.thirtyMaxLimit" [uppercaseRequired]="true" pInputText/>
              <label for="employeeLastName" [innerHTML]="sharedConstant[businessUnit].empOrParticipantsLastName"></label>
            </p-float-label>
          </div>
          <p class="sdps-text-right sdps-m-around_none sdps-text-small line-height-nml" *ngIf="reportDetails.get('employeeLastName').value && reportDetails.get('employeeLastName').value.length > showTextboxCharLimit">{{getShellConstant.reports.characterLimit}}
            <span class="character-limit">{{reportDetails.get('employeeLastName').value.length}} /{{getCommConst.charLimitValues.thirtyMaxLimit}}
            </span>
          </p>
        </div>
      </div>

      <div class="sdps-row sdps-p-top_large sdps-p-bottom_x-small select-report-type">
        <!-- Trade Result -->
        <div
          class="col-3 sdps-p-left_none">
          <div class="col-3 sdps-p-left_none employee-dropdown employee-association-dropdown">
              <!-- <p-float-label variant="in"> -->
              <p-select #dropdown inputId="tradeResult" [attr.aria-label]="getShellConstant.reports.presetReports.tradeResult" [options]="tradeResultsDropDownData" formControlName="tradeResultsDropDownData"></p-select>
              <label for="tradeResult" [ngClass]="{'emp-label': dropdown.value !== null}"
                      [innerHTML]="getShellConstant.reports.presetReports.tradeResult"></label>
            <!-- </p-float-label> -->
          </div>
        </div>

        <!-- Trade Symbol -->
        <div class="col-3 sdps-p-left_none">
          <div [ngClass]="{'invalidField': (reportDetails.get('tradeSymbol').value && reportDetails.get('tradeSymbol').invalid), 'disabled-grey': reportDetails.get('tradeSymbol').disabled}">
            <p-float-label variant="in">
              <input type="text" id="tradeSymbol" name="tradeSymbol" emsAlphaNumericSpecialCharacterValidation [maxlength]="100" formControlName="tradeSymbol" pInputText/>
              <label for="tradeSymbol" [innerHTML]="getShellConstant.reports.presetReports.tradeSymbol"></label>
            </p-float-label>
          </div>
        </div>

        <!-- CUSIP Symbol -->
        <div class="col-3 sdps-p-left_none">
          <div [ngClass]="{'invalidField': (reportDetails.get('cusipSymbol').value && (reportDetails.get('cusipSymbol').invalid || reportDetails.get('cusipSymbol').value.length < 9)), 'disabled-grey': reportDetails.get('cusipSymbol').disabled}">
            <p-float-label variant="in">
              <input type="text" id="cusipSymbol" name="cusipSymbol" emsAlphaNumericSpecialCharacterValidation [maxlength]="9" formControlName="cusipSymbol" pInputText/>
              <label for="cusipSymbol" [innerHTML]="getShellConstant.reports.presetReports.cusipSymbol"></label>
            </p-float-label>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ems-step-wizard-buttons [showCancelBtn]="true" (closeBtn)="cancelReport()" [showRunReportBtn]="true" (runReport)="runReports()"
                           [disableBtn]="reportDetails.invalid || endDateLessThanStartDate || dateRangeConstarint || dateError || (reportDetails.get('employeeAccount').value && reportDetails.get('employeeAccount').value.length <= 8) || (reportDetails.get('cusipSymbol').value && reportDetails.get('cusipSymbol').value.length < 9)"></ems-step-wizard-buttons>
</div>
